import { useCallback, useMemo } from "react";
import { t } from "@lingui/macro";
import {
  ErrorBoundary,
  GlobalHeader,
  postClose,
  useHeaderContext,
} from "@WahooFitness/wahoo-offline-mfe";
import useMembership from "./useMembership";
import NonSubscribedPage from "./NonSubscribedPage";
import SubscriptionPage from "./SubscriptionPage";
import { WfIconNavigationCloseRegular } from "@WahooFitness/redesignr";
import { Container } from "@mui/material";

interface MembershipProps {
  closeOnBack: boolean;
  referrer?: string;
  fromParam?: string;
}

function Membership({ closeOnBack, referrer, fromParam }: MembershipProps) {
  const {
    subscriptionError,
    subscriptionIsLoading,
    nonSubscribedData,
    subscriptionData,
    offeringsLoading,
    hasActiveSub,
  } = useMembership(referrer);
  const { navigateBack } = useHeaderContext();

  const cameFromSettings = useMemo(
    () => fromParam && ["fitness_profile"].includes(fromParam),
    [fromParam]
  );

  const closeAction = useCallback(() => {
    if (!cameFromSettings) {
      postClose("membership");
    } else {
      navigateBack();
    }
  }, [cameFromSettings, navigateBack]);

  return (
    <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
      <ErrorBoundary
        isLoading={subscriptionIsLoading || offeringsLoading}
        error={subscriptionError}
        onReload={() => {}}
        showError
      >
        <GlobalHeader
          title={closeOnBack ? t`Wahoo membership` : t`My subscription`}
          primaryLeftActionItem={
            closeOnBack
              ? {
                  icon: <WfIconNavigationCloseRegular />,
                  action: closeAction,
                }
              : undefined
          }
        />
        {hasActiveSub && subscriptionData ? (
          <SubscriptionPage subscriptionData={subscriptionData} />
        ) : (
          <NonSubscribedPage nonSubscribedData={nonSubscribedData} />
        )}
      </ErrorBoundary>
    </Container>
  );
}

export default Membership;
